import { Location } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from 'components/base/base.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { interval, lastValueFrom, Subject, takeUntil } from 'rxjs';
import { Perfil } from 'src/app/shared/enums/Perfis/Perfis';
import { ArquivoAzure } from 'src/app/shared/models/arquivo/ArquivoAzure';
import { Envolvido } from 'src/app/shared/models/chamados/envolvido';
import { ListarChamados } from 'src/app/shared/models/chamados/listar-chamados';
import { DefaultResponse } from 'src/app/shared/models/DefaultResponse';
import { Diretoria } from 'src/app/shared/models/diretoria/Diretoria';
import { Aluno } from 'src/app/shared/models/envolvidos/aluno';
import { Funcionario } from 'src/app/shared/models/envolvidos/funcionario';
import { Escola } from 'src/app/shared/models/escola/Escola';
import { FiltroPadrao } from 'src/app/shared/models/filtro-padrao/filtroPadrao';
import { AgendamentoPrevencaoDto } from 'src/app/shared/models/psicologo/AgendamentoPrevencaoDto';
import { Psicologo } from 'src/app/shared/models/psicologo/Psicologo';
import { RegistroAtividadePsicologoCheckOut } from 'src/app/shared/models/psicologo/RegistroAtividadePsicologoCheckOut';
import { AtribuicaoLoginSed } from 'src/app/shared/models/sed/UserLogin';
import { Turma } from 'src/app/shared/models/turma/Turma';
import { AlunoService } from 'src/app/shared/services/alunos.service';
import { ArquivoService } from 'src/app/shared/services/arquivo.service';
import { ChamadoService } from 'src/app/shared/services/chamado.service';
import { ConvivaErrorHandlingService } from 'src/app/shared/services/convivaErrorHandlingService';
import { EnvolvidoService } from 'src/app/shared/services/envolvido.service';
import { FiltroService } from 'src/app/shared/services/filtro.service';
import { FuncionarioService } from 'src/app/shared/services/funcionarios.service';
import { angularCommonImports } from 'src/app/shared/ui/angular-common';
import { convivaCommonImports } from 'src/app/shared/ui/conviva-common';
import { libsCommonImports } from 'src/app/shared/ui/libs-common';
import { GenericValidator } from 'src/app/shared/validations/genericValidators';
import { SpeechRecognitionService } from 'src/app/speech-recognition.service';
import { CellComponent } from 'tabulator-tables';
import { jornadaEstaAprovada } from 'src/app/shared/utils/jornada-em-aberto-modal';

@Component({
    templateUrl: './registro-atividade.component.html',
    styleUrls: ['./registro-atividade.component.scss'],
    standalone: true,
    imports:[angularCommonImports,convivaCommonImports,libsCommonImports]
})

export class PageRegistroAtividadeComponent extends BaseComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  private _tiposAtividadeOriginal: any[] = [];

  public submitted: boolean = false;
  /** Impede double-submit em "Salvar" durante o POST e o redirect de 5s. */
  public isSalvandoAtividade = false;
  //public duracaoVisita = 15;

  formInserir!: FormGroup;
  formModalAluno!: FormGroup;
  formModalOutros!: FormGroup;
  formModalEquipeEscolar!: FormGroup;
  isListening = false;
  codigoChamado: number = 0;
  // codigoEscola?: number;
  parametroId = 0;
  possuiJornadaAtivaValida = false;
  private inicioRegistro = 0;            // marca o instante em ms
  public tempoRegistro = '00:00';      // exibe/manda p/ backend
  codigoAgendamento: number = 0;
  public showBuscarPorNome = false;

  /** #163922 — voz/texto devem atualizar o FormControl (evita tela com texto e payload null). */
  private appendTextoFormControl(controlName: 'acaoRealizada' | 'proximosPassos', transcript: string): void {
    const control = this.formInserir?.get(controlName);
    if (!control) return;

    const atual = (control.value ?? '') as string;
    const novo = `${atual}${transcript}`.slice(0, 500);
    control.setValue(novo);
    control.markAsDirty();
    control.markAsTouched();
    this.OnChangeCountLetters(controlName === 'acaoRealizada' ? 1 : 2);
  }

  toggleListeningAcaoRealizada() {
    if (this.isListening) {
      this.speechRecognitionService.stopListening();
      this.isListening = false;
    } else {
      this.isListening = true;
      this.speechRecognitionService.startListening()
        .then(transcript => {
          this.appendTextoFormControl('acaoRealizada', transcript);
          this.isListening = false;
        })
        .catch(error => {
          console.error('Erro no reconhecimento de voz:', error);
          this.isListening = false;
          if (error === 'Reconhecimento de voz não é suportado neste navegador') {
            this.toastr.warning('O reconhecimento de voz não é suportado neste navegador. Por favor, digite o texto manualmente.');
          }
        });
    }
  }

  toggleListeningProximosPassos() {
    if (this.isListening) {
      this.speechRecognitionService.stopListening();
      this.isListening = false;
    } else {
      this.isListening = true;
      this.speechRecognitionService.startListening()
        .then(transcript => {
          this.appendTextoFormControl('proximosPassos', transcript);
          this.isListening = false;
        })
        .catch(error => {
          console.error('Erro no reconhecimento de voz:', error);
          this.isListening = false;
          if (error === 'Reconhecimento de voz não é suportado neste navegador') {
            this.toastr.warning('O reconhecimento de voz não é suportado neste navegador. Por favor, digite o texto manualmente.');
          }
        });
    }
  }

  setJornadaId() {
    this.parametroId = Number(this.route.snapshot.queryParamMap.get('id') ?? 0);
    this.route
      .queryParams
      .subscribe(params => this.parametroId = Number(params.id ?? 0));

  }
  
  ngOnInit(): void {
    this.inicializar();
  }

  private async inicializar(): Promise<void> {

    this.setJornadaId();

    this.formInserir = new FormGroup({

      nomePsicologo: new FormControl({ value: this.userLogado?.nome, disabled: false }),
      tituloAcao: new FormControl(null, [Validators.required]),
      duracaoAcao: new FormControl(15),
      tipoAtividade: new FormControl(null, Validators.required),
      codigoAtividade: new FormControl(null),
      tipoGrupo: new FormControl(null),
      acaoRealizada: new FormControl(null, [Validators.required, Validators.minLength(50), Validators.maxLength(500)]),
      proximosPassos: new FormControl(null, [Validators.required, Validators.minLength(50), Validators.maxLength(500)]),
      arquivos: new FormControl(null),
      codigoEscolaApenasDiretoria: new FormControl(null),
    });

    this.possuiJornadaAtivaValida = await this.validarJornadaAtivaParaRegistro();
    if (!this.possuiJornadaAtivaValida) {
      return;
    }


    /* ➊ marca o instante em que o usuário abre a tela */
    this.inicioRegistro = performance.now();

    interval(1000)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.tempoRegistro = this.formatElapsed());


    this.getPsicologoPorCPF();
    this.formInserir.get('codigoEscolaApenasDiretoria')?.setValue(this.userLogado?.codigoEscola) ;

    this._tiposAtividadeOriginal = [...this.tiposAtividade];

    if (this.userLogado?.codigoPerfil === 1632) {
    // Mantém somente Acolhimento (1) e Prevenção (3) caso seja coordenador psi
    this.tiposAtividade = this._tiposAtividadeOriginal.filter(x => [1, 3].includes(x.value));


  }

  }

  private async validarJornadaAtivaParaRegistro(): Promise<boolean> {
    if (!this.parametroId) {
      this.toastr.warning('Código da jornada não informado.');
      this.router.navigate(['/registro-saida']);
      return false;
    }

    try {
      const response = await lastValueFrom(this.psicologoService.getJornadaPorId(this.parametroId));
      if (!response.isSucess || !response.data) {
        this.toastr.error(response?.message ?? 'Não foi possível carregar a jornada.', response?.title ?? 'Atenção');
        this.router.navigate(['/registro-saida']);
        return false;
      }

      if (!response.data.dataInicio) {
        this.toastr.warning('Jornada sem check-in registrado.');
        this.router.navigate(['/registro-saida']);
        return false;
      }

      const perfil = this.userLogado?.codigoPerfil;
      const exigeJornadaAtiva = perfil === Perfil.Psicólogo || perfil === Perfil.CoordenadorPsicologo;

      if (jornadaEstaAprovada(response.data)) {
        this.toastr.warning('Não é permitido adicionar atividades em jornadas aprovadas.');
        this.router.navigate(['/registro-saida']);
        return false;
      }

      if (exigeJornadaAtiva) {
        const jornadaAberta = await lastValueFrom(this.psicologoService.getJornadaEmAberto(this.userLogado?.cpf!))
          .catch((err) => {
            this.errorHandler.handleResultError(err);
            return null;
          });

        if (!jornadaAberta?.isSucess || !jornadaAberta.data) {
          this.toastr.warning('Registro de atividades permitido apenas durante jornada ativa.');
          this.router.navigate(['/registro-saida']);
          return false;
        }
      }

      return true;
    } catch (error) {
      this.errorHandler.handleResultError(error);
      this.router.navigate(['/registro-saida']);
      return false;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private formatElapsed(): string {
    const sec = Math.floor((performance.now() - this.inicioRegistro) / 1000);
    return `${String(Math.floor(sec / 60)).padStart(2, '0')}:${String(sec % 60).padStart(2, '0')}`;
  }




  //Objetos e filtros
  public psicologo: Psicologo;
  public lstOcorrenciasAgendadas: ListarChamados[] = [];
  public lstAgendamentoPrevencao: AgendamentoPrevencaoDto[] = [];
  //public lstEnvolvidos: Envolvido[] = [];
  public lstEnvolvidosSelecionados: Envolvido[] = [];
  public alunosSelecionados: Aluno[] = [];
  public alunos: Aluno[] = [];
  public escolasModalAlunos: Escola[] = [];
  public aluno: Aluno = <Aluno>{};
  public lstTurmas: Turma[] = [];
  escolasDiretor: Escola[] = this.escolas;
  public lstTurmasAtivas: number[] = [];
  public lstTurmasSelecionadas: Turma[] = [];
  public envolvidos: Envolvido[] = [];
  public qtdeCaracteresAcao: number = 0;
  public qtdeCaracteresPassos: number = 0;
  lstFuncionariosSelecionados: Funcionario[] = [];
  public lstFuncionarios: Funcionario[] = [];
  lstOutros: string[] = [];
  public files: ArquivoAzure[] = [];
  public codigoChamadoAtual: number = 0;
  public lstEnvolvidosAux: Envolvido[] = [];
  public jsonEnvolvidoAgendamento: Array<{codigoEnvolvido: number, codigoAgendamento: number}> = [];

  //Injections
  spinner = inject(NgxSpinnerService);
  errorHandler = inject(ConvivaErrorHandlingService);
  filtroService = inject(FiltroService);
  chamadoService = inject(ChamadoService);
  envolvidoService = inject(EnvolvidoService);
  alunoService = inject(AlunoService);
  speechRecognitionService = inject(SpeechRecognitionService);
  genericValidate = inject(GenericValidator);
  funcionarioService = inject(FuncionarioService);
  arquivoService = inject(ArquivoService);
  route = inject(ActivatedRoute);
  location = inject(Location);

  mostrarAgendados = false;
  mostrarNaoAgendados = false;


  mostrarGridAcolhimento = false;
  mostrarGridPrevencao = false;
  mostrarAlunos = false;
  mostrarAlunosPrevencao = false;
  showOpcoesPrevencao = false;
  showModalAluno = false;
  showDropAuxiliar = false;
  validaBuscaRA = false;
  mostrarGrupos = false;
  mostrarDivTurmas = false;
  mostrarDivEquipeEscolar = false;
  mostrarDivOutros = false;
  showModalOutros = false;
  submittedModal = false;
  showModalEquipeEscolar = false;
  showDropFuncionarios = false;
  
  // filtrosTabela:FiltroTabulator[] = [
  //   {
  //     value:'nomePsicologo',
  //     label:'Psicólogo'
  //   },
  //   {
  //     value:'dataEntrada',
  //     label:'Data Entrada'
  //   },
  //   {
  //     value:'poloDiretoria',
  //     label:'Polo/Diretoria'
  //   }
  // ] ;

  // get podeVerColuna() {
  //   return [
  //     Perfil.GestorConviva,
  //     Perfil.GestorCGRH,
  //     Perfil.PEC,
  //     Perfil.CoordenadorPsicologo,
  //     Perfil.FiscalPsicologo
  //   ].includes(this.userLogado?.codigoPerfil!);
  // }

  // public colunasGrid =  [
  //   { title: 'Psicólogo', field: 'nomePsicologo', width:200, hozAlign: "center",headerHozAlign:"center"  },
  //   { title: 'Data Entrada', field: 'dataEntrada', width:150, hozAlign: "center",headerHozAlign:"center" },
  //   { title: 'Observação', field: 'observacao', width:200, hozAlign: "center",headerHozAlign:"center",formatter:this.observacaoFormatter},
  //   { title: 'Entrada / Saída', field: 'entradaSaida',width:150 ,hozAlign: "center" },
  //   { title: 'Polo / Diretoria', field: 'poloDiretoria', width:200, hozAlign: "center",headerHozAlign:"center", formatter:"textarea" },
  //   { title: 'Escola', field: 'escolaFormatada', width:200, hozAlign: "center",headerHozAlign:"center", formatter:"textarea" },
  //   { title: 'Lat/Long Inicio', field: 'latLongInicio', width:180, hozAlign: "center",headerHozAlign:"center"  },
  //   { title: 'Distância Inicio', field: 'distanciaEscolaInicio', width:150, hozAlign: "center",headerHozAlign:"center" , visible:this.podeVerColuna},
  //   { title: 'Lat/Long Fim', field: 'latLongFim', width:180, hozAlign: "center",headerHozAlign:"center"  },
  //   { title: 'Distância Fim', field: 'distanciaEscolaFim', width:150, hozAlign: "center",headerHozAlign:"center" ,visible:this.podeVerColuna },
  //   { title: 'Tipo Registro', field: 'tipoRegistroInicio', width: 150, hozAlign: 'center', headerHozAlign: 'center', formatter: 'lookup', formatterParams: { 1: 'Automático', 2: 'Manual', 3: 'Ajustado',},},

  //   ];


  setUserLogado() {
    const user = this.authService.getUser();
    if (!user)
      this.router.navigate(['/logout']);

    return user;
  }

  public gridAcolhimentoAgendado = [
    { title: 'DE', field: 'nomeDiretoria', width: 150, hozAlign: "center", headerHozAlign: "center" },
    { title: 'Escola', field: 'nomeEscola', width: 200, hozAlign: "center", headerHozAlign: "center", formatter: "textarea" },
    { title: 'Código Chamado', field: 'codigoChamado', width: 150, hozAlign: "center", headerHozAlign: "center", formatter: "textarea" },
    { title: 'Envolvido', field: 'tipoEnvolvidoAgendamento', width: 200, hozAlign: "center", headerHozAlign: "center", formatter: "textarea", mutator: (value: string, data: ListarChamados) => { return data.tipoEnvolvidoAgendamento + ' - ' + data.nomeEnvolvido; } },
    {
      title: 'Data agendamento', field: 'dataAgendamento', width: 150, hozAlign: "center", headerHozAlign: "center", formatter: function (cell: any) {
        const value = cell.getValue();
        if (!value) return '';

        const date = new Date(value);
        if (isNaN(date.getTime())) return value;

        const dia = String(date.getDate()).padStart(2, '0');
        const mes = String(date.getMonth() + 1).padStart(2, '0');
        const ano = date.getFullYear();

        return `${dia}/${mes}/${ano}`;
      }
    },
    {
      title: 'Ações',
      field: 'acoes',
      hozAlign: "center",
      headerHozAlign: "center",
      width: 100,
      formatter: "toggle",
      formatterParams: {
        size: 20,
        onValue: true,
        offValue: false,
        onColor: "green",
        offColor: "grey",
        clickable: true
      },
      cellMouseDown: (e: MouseEvent, cell: CellComponent) => {
        const table = cell.getTable();
        const currentValue = cell.getValue();

        const rowData = cell.getData();
        const currentCodigoChamado = rowData.codigoChamado;
        const selecionarMultiplosEnvolvidos = this.formInserir.get('tipoAtividade')?.value === 2;

        if (!currentValue) {

          if(selecionarMultiplosEnvolvidos){
            if(this.codigoChamadoAtual !== currentCodigoChamado){
              // Desmarca todos os outros toggles
              table.getRows().forEach((row) => {
                if (row !== cell.getRow()) {
                  row.update({ acoes: false });
                  this.lstEnvolvidosSelecionados = [];
                  //this.lstEnvolvidos = [];
                  this.jsonEnvolvidoAgendamento = [];
                }
              });
            }

            this.codigoChamadoAtual = currentCodigoChamado;
            this.addJsonPorCodigoEnvolvido(rowData.codigoEnvolvido, rowData.codigoAgendamento);
          }
          else
          {
            // Desmarca todos os outros toggles
            table.getRows().forEach((row) => {
              if (row !== cell.getRow()) {
                row.update({ acoes: false });
                this.lstEnvolvidosSelecionados = [];
              }
            });
          }

          // Marca o toggle atual
          cell.setValue(true);

          // Chama a função desejada com os dados da linha

          //const rowData = cell.getData();
          this.codigoAgendamento = rowData.codigoAgendamento;
          this.exibirEnvolvidosAcolhimentoAgendado(e, cell, true);
        } else {

          if(selecionarMultiplosEnvolvidos){

            this.removerPorCodigoEnvolvido(rowData.codigoEnvolvido);
            this.removerJsonPorCodigoEnvolvido(rowData.codigoEnvolvido);

            const estaVazia = this.lstEnvolvidosSelecionados.length === 0;
            if(estaVazia){
              cell.setValue(false);
              this.mostrarAlunos = false;
              this.codigoAgendamento = 0;
            }
            else{
              cell.setValue(false);
              this.mostrarAlunos = true;
              this.codigoAgendamento = this.jsonEnvolvidoAgendamento[0]?.codigoAgendamento;
            }
          }
          else{
            // Desmarca o toggle atual
            cell.setValue(false);
            this.mostrarAlunos = false;
            this.codigoAgendamento = 0;
          }
        }
      }
    }
  ];

  public gridPrevencaoAgendado = [
    { title: 'DE', field: 'nomeDiretoria', width: 150, hozAlign: "center", headerHozAlign: "center" },
    { title: 'Escola', field: 'nomeEscola', width: 200, hozAlign: "center", headerHozAlign: "center", formatter: "textarea" },
    { title: 'Código Prevenção', field: 'codigoAgendamento', width: 150, hozAlign: "center", headerHozAlign: "center", formatter: "textarea" },
    { title: 'Psicólogo', field: 'nomePsicologo', width: 200, hozAlign: "center", headerHozAlign: "center" },
    {
      title: 'Data agendamento', field: 'dataAgendamento', width: 150, hozAlign: "center", headerHozAlign: "center", formatter: function (cell: any) {
        const value = cell.getValue();
        if (!value) return '';

        const date = new Date(value);
        if (isNaN(date.getTime())) return value;

        const dia = String(date.getDate()).padStart(2, '0');
        const mes = String(date.getMonth() + 1).padStart(2, '0');
        const ano = date.getFullYear();

        return `${dia}/${mes}/${ano}`;
      }
    },
    {
      title: 'Ações',
      field: 'acoes',
      hozAlign: "center",
      headerHozAlign: "center",
      width: 100,
      formatter: "toggle",
      formatterParams: {
        size: 20,
        onValue: true,
        offValue: false,
        onColor: "green",
        offColor: "grey",
        clickable: true
      },
      cellMouseDown: (e: MouseEvent, cell: CellComponent) => {
        const table = cell.getTable();
        const currentValue = cell.getValue();

        if (!currentValue) {
          // Desmarca todos os outros toggles
          table.getRows().forEach((row) => {
            if (row !== cell.getRow()) {
              row.update({ acoes: false });
              this.lstEnvolvidosSelecionados = [];
            }
          });

          // Marca o toggle atual
          cell.setValue(true);

          // Chama a função desejada com os dados da linha
          const rowData = cell.getData();
          this.codigoAgendamento = rowData.codigoAgendamento;
        } else {
          // Desmarca o toggle atual
          cell.setValue(false);
          this.mostrarAlunos = false;
          this.codigoAgendamento = 0;
        }
      }
    }
  ];

  public gridTurmasPrevencao = [
    { title: 'Código da Turma', field: 'codigoTurma', width: 150, hozAlign: "center", headerHozAlign: "center" },
    { title: 'Número Classe', field: 'numeroClasse', width: 200, hozAlign: "center", headerHozAlign: "center", formatter: "textarea" },
    { title: 'Tipo de Ensino', field: 'nomeTipoEnsino', width: 150, hozAlign: "center", headerHozAlign: "center", formatter: "textarea" },
    { title: 'Número de Série', field: 'numeroSerie', width: 200, hozAlign: "center", headerHozAlign: "center", formatter: "textarea" },
    { title: 'Descrição Turma', field: 'descricaoTurma', width: 200, hozAlign: "center", headerHozAlign: "center" },
    {
      title: 'Ações',
      field: 'acoes',
      hozAlign: "center",
      headerHozAlign: "center",
      width: 100,
      formatter: "toggle",
      formatterParams: {
        size: 20,
        onValue: true,
        offValue: false,
        onColor: "green",
        offColor: "grey",
        clickable: true
      },
      cellMouseDown: (e: MouseEvent, cell: CellComponent) => {
        const rowData = cell.getData();
        const codigoTurma = rowData.codigoTurma;
        const descricaoTurma = rowData.descricaoTurma;

        // Chama a função onCheckTurma com os dados da linha
        this.onCheckTurma(codigoTurma, descricaoTurma);

        // Alterna o valor do toggle
        const currentValue = cell.getValue();
        cell.setValue(!currentValue);
      }
    }
  ];

  public async exibirEnvolvidosAcolhimentoAgendado(e: any, cell: any, toggleValue: boolean) {
    const rowData = cell.getData();
    const codigoChamado = rowData.codigoChamado;
    const codigoEnvolvido = rowData.codigoEnvolvido;
    await this.getEnvolvidosPorChamado(codigoChamado, codigoEnvolvido);
    this.mostrarAlunos = true;
  }

  public async getEnvolvidosPorChamado(codigoChamado: number, codigoEnvolvido: number) {
    this.spinnerService.show();
    this.codigoChamado = codigoChamado;
    const selecionarMultiplosEnvolvidos = this.formInserir.get('tipoAtividade')?.value === 2;

    const response = await lastValueFrom(
      this.envolvidoService.GetEnvolvidosPorChamadoEPsicologo(codigoChamado, this.psicologo.codigoPsicologo!)
    );

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    if(selecionarMultiplosEnvolvidos){
      this.lstEnvolvidosAux = response.data;
      this.lstEnvolvidosSelecionados.push(...this.lstEnvolvidosAux.filter(x => x.codigoEnvolvido == codigoEnvolvido));
      this.lstEnvolvidosAux = [];
    }
    else
    {
      this.lstEnvolvidosSelecionados = response.data;
      this.lstEnvolvidosSelecionados = this.lstEnvolvidosSelecionados.filter(x => x.codigoEnvolvido == codigoEnvolvido);
    }


    this.spinnerService.hide();

  }

  //public addEnvolvidoOnLstEnvolvidoSelecionado(codigoEnvolvido: number,  target: EventTarget) {
  //  const checkbox = target as HTMLInputElement;
  //  if (checkbox.checked)
  //    this.lstEnvolvidosSelecionados.push(this.lstEnvolvidos.find(x => x.codigoEnvolvido == codigoEnvolvido)!);
  //  else
  //    this.lstEnvolvidosSelecionados = this.lstEnvolvidosSelecionados.filter(x => x.codigoEnvolvido != codigoEnvolvido);
  //}

  public async carregarTurmas() {
    this.submitted = true;
    let codigoEs = this.filtros.codigoEscola ?? this.userLogado?.codigoEscola;
    if (this.formInserir.get('codigoEscolaApenasDiretoria')?.value)
      codigoEs = this.formInserir.get('codigoEscolaApenasDiretoria')?.value;

    if (codigoEs != null) {
      this.spinnerService.show();
      const result = await lastValueFrom(this.escolaService.getTurmasPorCodigoCie(codigoEs, 0))
        .catch((err) => {
          return this.errorHandler.handleResultError(err);
        });
      if (!result.isSucess) {
        this.toastr.error(result.message, result.title);
        this.spinnerService.hide();
        return;
      }
      this.lstTurmas = result.data;
      this.spinnerService.hide();
      this.mostrarDivTurmas = true;
    }
  }

  async onChangeCodigoEscola() {

    const formData = this.formInserir.value;
    // this.codigoEscola = event?.codigoEscola ;

    this.lstEnvolvidosSelecionados = [];
    if (formData.tipoAtividade == 2){
      this.mostrarGridAcolhimento = true;
      await this.getOcorrencias();
    }

    if (formData.tipoAtividade == 4){

      this.mostrarGridPrevencao = true;
      await this.getPrevencaoAgendada();
    }


    if (formData.tipoAtividade == 1 || formData.tipoAtividade == 3){
        this.lstTurmas = [];
        this.lstTurmasSelecionadas = [];

      await this.carregarTurmas();

    }


  }




  async searchHandler(event: FiltroPadrao) {
    this.filtros = event;
    this.syncPainelTipoAtividadeSeFiltroPronto();
  }


  async listeningFiltroEmitter(eventFilter: FiltroPadrao) {
    this.setFilters(eventFilter);
    this.filtroService.atualizaFiltro(eventFilter);
  }

  setFilters(event: FiltroPadrao) {
    this.filtros = event;
  }



  public async getOcorrencias() {
    this.spinnerService.show();

    //   // Verifica se os parâmetros obrigatórios estão presentes
    // if (!this.filtros.codigoDiretoria || !this.filtros.codigoEscola) {
    //   alert('Por favor, selecione a Diretoria e Escola antes de buscar as ocorrências.');
    //   return;
    // }

    const codigoPsicologo = this.psicologo.codigoPsicologo;
    const codigoEscola =   this.formInserir.get('codigoEscolaApenasDiretoria')?.value ?? this.filtros.codigoEscola;
    const codigoDiretoria = this.filtros.codigoDiretoria;

    try {
      const result = await lastValueFrom(this.chamadoService.getChamadosAgendados(codigoEscola, codigoPsicologo, codigoDiretoria));
      this.lstOcorrenciasAgendadas = result.data;
    } catch (err) {
      this.errorHandler.handleResultError(err);
    } finally {
      this.spinnerService.hide();
    }
  }

  public async getPrevencaoAgendada() {

    this.spinnerService.show();
    const codigoPsicologo = this.psicologo.codigoPsicologo;
    const codigoEscola = this.formInserir.get('codigoEscolaApenasDiretoria')?.value?? this.filtros.codigoEscola;
    const codigoDiretoria = this.filtros.codigoDiretoria;

    try {
      const result = await lastValueFrom(this.psicologoService.getAgendamentosPrevencao(codigoEscola!, codigoDiretoria, codigoPsicologo!));
      this.lstAgendamentoPrevencao = result.data;
      this.spinnerService.hide();
    } catch (err) {
      this.errorHandler.handleResultError(err);
    }
  }
   private async enviarAtividadeParaAprovacaoAutomaticamente(codigosAtividade: number[]) {
    if (!codigosAtividade || codigosAtividade.length === 0) {
      return;
    }

    try {
      const response = await lastValueFrom(
        this.psicologoService.setEnviarParaAprovacaoAtividades(
          codigosAtividade,
          this.userLogado?.codigoUsuario!,
          this.userLogado?.nome!,
          this.parametroId
        )
      );

      if (!response.isSucess) {
        this.toastr.error(response.message, response.title);
        return;
      }

      this.toastr.success('Atividade enviada para aprovação!');
    } catch (err) {
      this.errorHandler.handleResultError(err);
    }
  }

   public async registrarAtividade() {

    if (!this.possuiJornadaAtivaValida) {
      return;
    }

    // Evita double-submit (cliques múltiplos / cliques durante o redirecionamento).
    if (this.isSalvandoAtividade) {
      return;
    }

    this.spinnerService.show();
    this.submitted = true;
    if (this.formInserir.invalid) {
      this.toastr.error('Preencha os campos obrigatórios');
      this.spinnerService.hide();
      return;
    }

    const formData = this.formInserir.value;

    ////////REGISTRO DE ATIVIDADES AGENDADAS (Acolhimento e Prevenção)///////////////////////////
    if (formData.tipoAtividade == 2 || formData.tipoAtividade == 4) {
      if (!this.formInserir.get('tipoAtividade')?.value) {
        this.toastr.warning('Selecione um tipo de atividade.');
      }

      if (formData.tipoAtividade == 2 && this.lstEnvolvidosSelecionados.length === 0) {
        this.toastr.warning('Selecione pelo menos um envolvido para a atividade agendada.');
        this.spinnerService.hide();
        return;
      }

      if (formData.tipoAtividade == 4 && !this.codigoAgendamento) {
        this.toastr.warning('Selecione pelo menos um agendamento para a atividade agendada.');
        this.spinnerService.hide();
        return;
      }

      this.isSalvandoAtividade = true;
      const parametrosAtividadeAgendada = this.setParametrosAtividadesAgendadas();

      try {
        let retorno;

        if (formData.tipoAtividade == 2) {
          retorno = await lastValueFrom(this.psicologoService.setCadastrarAtividadePsicologoJornadaMultiEnvolvido(parametrosAtividadeAgendada));
        } else {
          retorno = await lastValueFrom(this.psicologoService.setCadastrarAtividadePsicologoJornada(parametrosAtividadeAgendada));
        }

        if (!retorno.isSucess) {
          this.isSalvandoAtividade = false;
          this.toastr.error(retorno.message);
          this.spinnerService.hide();
          return;
        }
        if (this.userLogado?.codigoPerfil === 1632) {// Coordenador Psicólogo

          const codigoAtividade = retorno.data?.codigoGrande;
          const codigosAtividade = codigoAtividade ? [codigoAtividade] : [];

          await this.enviarAtividadeParaAprovacaoAutomaticamente(codigosAtividade);
        }
        this.toastr.success('Atividade registrada com sucesso!');
        this.toastr.success('Redirecionando para o ínicio em 5 segundos.');

        // Mantém spinner e botão desabilitado durante os 5s até o redirect.
        setTimeout(() => {
          this.spinnerService.hide();
          this.router.navigate(['/registro-saida'], {
            queryParams: {
              jornada: this.parametroId,
              ...(this.route.snapshot.queryParamMap.get('flow') === 'checkout'
                ? { flow: 'checkout' }
                : {})
            }
          });
        }, 5000);
      } catch (err) {
        this.isSalvandoAtividade = false;
        this.spinnerService.hide();
        this.errorHandler.handleResultError(err);
      }
      return;
    }
    ////REGISTRO DE ATIVIDADE NÃO AGENDADA(Acolhimento e Prevenção)/////////////////////
    if (formData.tipoAtividade == 1 || formData.tipoAtividade == 3) {
      if (!this.validaAtividadeNaoAgendada()) {
        this.spinnerService.hide();
        return;
      }
      this.validaFormularioAtividadeNaoAgendada();
      this.isSalvandoAtividade = true;
      const parametrosAtividadeNaoAgendada = this.setParametrosAtividadesNaoAgendadas();

      try {
        const response = await lastValueFrom(this.psicologoService.setCadastrarAtividadePsicologoJornada(parametrosAtividadeNaoAgendada));

        if (!response.isSucess) {
          this.isSalvandoAtividade = false;
          this.toastr.error(response.message);
          this.spinnerService.hide();
          return;
        }
        if (this.userLogado?.codigoPerfil === 1632) {// Coordenador Psicólogo

          const codigoAtividade = response.data?.codigoGrande;
          const codigosAtividade = codigoAtividade ? [codigoAtividade] : [];

          await this.enviarAtividadeParaAprovacaoAutomaticamente(codigosAtividade);
        }
        this.toastr.success('Atividade registrada com sucesso!');
        this.toastr.success('Redirecionando para o ínicio em 5 segundos.');
        this.spinnerService.hide();
        this.router.navigate(['/registro-saida'], {
          queryParams: {
            jornada: this.parametroId,
            ...(this.route.snapshot.queryParamMap.get('flow') === 'checkout'
              ? { flow: 'checkout' }
              : {})
          }
        });
      } catch (err) {
        this.isSalvandoAtividade = false;
        this.spinnerService.hide();
        this.errorHandler.handleResultError(err);
      }
      return;
    }
    this.spinnerService.hide();
    return;
  }

  public setParametrosAtividadesAgendadas(): RegistroAtividadePsicologoCheckOut {
    return {
      codigoJornada: this.parametroId,
      tempoRegistro: this.tempoRegistro,
      titulo: this.formInserir.get('tituloAcao')?.value,
      tempoAtividade: this.formInserir.get('duracaoAcao')?.value,
      tipoAtividade: this.formInserir.get('tipoAtividade')?.value,
      acaoRealizada: this.formInserir.get('acaoRealizada')?.value,
      proximosPassos: this.formInserir.get('proximosPassos')?.value,
      listaEnvolvidos: this.lstEnvolvidosSelecionados,
      codigoChamado: this.codigoChamado,
      arquivos: this.files,
      codigoAtividade: this.formInserir.get('codigoAtividade')?.value,
      codigoAgendamento: this.codigoAgendamento,
      codigoUsuario: this.userLogado?.codigoUsuario!,
      nomeUsuario: this.userLogado?.nome!,
      codigoPerfil: this.userLogado?.codigoPerfil,
      cpfUsuario: this.userLogado?.cpf,
      envolvidoAgendamento: this.jsonEnvolvidoAgendamento,
    };

  }

  public setParametrosAtividadesNaoAgendadas(): RegistroAtividadePsicologoCheckOut {
    return {
      codigoJornada: this.parametroId,
      tempoRegistro: this.tempoRegistro,
      titulo: this.formInserir.get('tituloAcao')?.value,
      tempoAtividade: this.formInserir.get('duracaoAcao')?.value,
      tipoAtividade: this.formInserir.get('tipoAtividade')?.value,
      acaoRealizada: this.formInserir.get('acaoRealizada')?.value,
      proximosPassos: this.formInserir.get('proximosPassos')?.value,
      arquivos: this.files,
      listaEnvolvidos: this.lstEnvolvidosSelecionados,
      lstFuncionariosSelecionados: this.lstFuncionariosSelecionados,
      lstOutros: this.lstOutros,
      tipoAtividadeRealizada: this.formInserir.get('tipoGrupo')?.value,
      codigoAtividade: this.formInserir.get('codigoAtividade')?.value,
      alunosSelecionados: this.alunosSelecionados,
      turmasSelecionadas: this.lstTurmasSelecionadas,
      codigoUsuario: this.userLogado?.codigoUsuario!,
      nomeUsuario: this.userLogado?.nome!,
      codigoPerfil: this.userLogado?.codigoPerfil,
      cpfUsuario: this.userLogado?.cpf,
      envolvidoAgendamento: this.jsonEnvolvidoAgendamento,

    };

  }

  private validaAtividadeNaoAgendada(): boolean {


    const codigoAtividade = +this.formInserir.get('codigoAtividade')!.value;
    const tipoGrupo = +this.formInserir.get('tipoGrupo')!.value;
    if (!this.formInserir.get('codigoAtividade')?.value) {
      this.toastr.warning('Selecione um tipo de atividade.');
      return false;
    }

    if (codigoAtividade === 2 && tipoGrupo === 0) {
      this.toastr.warning('Selecione um grupo.');
      return false;
    }



    if (codigoAtividade === 1 && this.alunosSelecionados.length === 0) {
      this.toastr.warning('Selecione pelo menos um Aluno para a atividade.');
      return false;
    }

    if (codigoAtividade === 2 && tipoGrupo === 1 && this.lstEnvolvidosSelecionados.length === 0) {
      this.toastr.warning('Selecione pelo menos uma Turma para a atividade.');
      return false;
    }

    if (codigoAtividade === 2 && tipoGrupo === 2 && this.lstFuncionariosSelecionados.length === 0) {
      this.toastr.warning('Selecione pelo menos um Funcionário para a atividade.');
      return false;
    }

    if (codigoAtividade === 2 && tipoGrupo === 3 && this.lstOutros.length === 0) {
      this.toastr.warning('Selecione pelo menos um outro envolvido para a atividade.');
      return false;
    }

    return true;
  }

  public validaFormularioAtividadeNaoAgendada() {
    if (this.formInserir.get('codigoAtividade')?.value == 1) {
      this.lstEnvolvidosSelecionados = [];
      this.lstFuncionariosSelecionados = [];
      this.lstOutros = [];
      this.lstTurmasSelecionadas = [];
    }
    if (this.formInserir.get('codigoAtividade')?.value == 2 && this.formInserir.get('tipoGrupo')?.value == 1) {
      this.lstEnvolvidosSelecionados = [];
      this.alunosSelecionados = [];
      this.lstFuncionariosSelecionados = [];
      this.lstOutros = [];
    }
    if (this.formInserir.get('codigoAtividade')?.value == 2 && this.formInserir.get('tipoGrupo')?.value == 2) {
      this.alunosSelecionados = [];
      this.lstEnvolvidosSelecionados = [];
      this.lstOutros = [];
      this.lstTurmasSelecionadas = [];
    }
    if (this.formInserir.get('codigoAtividade')?.value == 2 && this.formInserir.get('tipoGrupo')?.value == 3) {
      this.alunosSelecionados = [];
      this.lstEnvolvidosSelecionados = [];
      this.lstFuncionariosSelecionados = [];
      this.lstTurmasSelecionadas = [];
    }
  }



  public tiposAtividade = [
    { label: 'Acolhimento', value: 1 },
    { label: 'Acolhimento Agendado', value: 2 },
    { label: 'Prevenção', value: 3 },
    { label: 'Prevenção Agendado', value: 4 }
  ];

  /** ng-select pode emitir o modelo (número) ou o item `{ label, value }`. */
  private normalizeTipoAtividadeChangeEvent(event: unknown): number | null {
    if (event == null) {
      return null;
    }
    const raw =
      typeof event === 'object' && event !== null && 'value' in event
        ? (event as { value: unknown }).value
        : event;
    if (raw == null || raw === '') {
      return null;
    }
    const n = Number(raw);
    return Number.isNaN(n) ? null : n;
  }

  /**
   * Atualiza painéis (não agendado / agendado) conforme o tipo 1–4.
   * Também chamado após sincronizar URE no filtro, quando o usuário já tinha escolhido o tipo mas
   * `onTipoAtividadeChange` tinha retornado antes por `codigoDiretoria` ainda vazio no `this.filtros`.
   */
  private applyTipoAtividadeSelectionSideEffects(tipoAtividade: number | null): void {
    if (tipoAtividade == null) {
      return;
    }
    this.lstEnvolvidosSelecionados = [];
    this.mostrarAlunos = false;
    if (tipoAtividade === 1) {
      this.mostrarAgendados = false;
      this.mostrarNaoAgendados = true;
    }
    if (tipoAtividade === 2) {
      if (!this.filtros.codigoEscola && this.filtros.codigoEscola == 0) {
        this.escolas = []
      }

      this.getOcorrencias();
      this.mostrarGridAcolhimento = this.filtros.codigoEscola ? true : !!this.formInserir.get('codigoEscolaApenasDiretoria')?.value;
      this.mostrarAgendados = true;
      this.mostrarGridPrevencao = false;
      this.mostrarNaoAgendados = false;
    }

    if (tipoAtividade === 3) {
      this.mostrarAgendados = false;
      this.mostrarNaoAgendados = true;
    }

    if (tipoAtividade === 4) {
      this.getPrevencaoAgendada();
      this.mostrarGridAcolhimento = false;
      this.mostrarGridPrevencao = this.filtros.codigoEscola ? true : !!this.formInserir.get('codigoEscolaApenasDiretoria')?.value;
      this.mostrarAgendados = true;
      this.mostrarNaoAgendados = false;
    }
  }

  private syncPainelTipoAtividadeSeFiltroPronto(): void {
    const tipo = this.normalizeTipoAtividadeChangeEvent(this.formInserir.get('tipoAtividade')?.value);
    if (tipo != null && this.filtros?.codigoDiretoria) {
      this.applyTipoAtividadeSelectionSideEffects(tipo);
    }
  }

  public onTipoAtividadeChange(event: any): void {
    this.formInserir.get('codigoEscolaApenasDiretoria')?.setValue(null);
    if (!this.filtros?.codigoDiretoria) {
      this.toastr.warning('Selecione a Diretoria para poder selecionar um tipo de atividade.');
      return;
    }
    const tipoAtividade = this.normalizeTipoAtividadeChangeEvent(event);
    this.applyTipoAtividadeSelectionSideEffects(tipoAtividade);
  }

  public async getPsicologoPorCPF(): Promise<void> {
    const cpf = this.userLogado?.cpf;
    if (!cpf) {
      return;
    }

    try {
      const result = await lastValueFrom(this.psicologoService.getPsicologoPorCPF(cpf));
      this.psicologo = result.data;
    } catch (err) {
      this.errorHandler.handleResultError(err);
    }
  }

  public lstAtividadeRealizada = [{ id: 1, name: "Conversa/Atividade com indivíduo(os)" },
  { id: 2, name: "Conversa/atividade em grupo" },
  ];

  public lstGrupos = [{ id: 1, name: "Turmas participantes da atividade" }, { id: 2, name: "Equipe escolar" }, { id: 3, name: "Outros" }];
  public tipoPessoaAdd = [{
    descricao: 'Outros',
    id: 1
  }, {
    descricao: 'Profissional',
    id: 2
  }]

  public IsEnvolvidoSelected(envolvido: Envolvido): boolean {
    return this.lstEnvolvidosSelecionados.includes(envolvido);
  }


  public opcoesPrevencao() {
    const codigoAtividade = this.formInserir.get('codigoAtividade')?.value;

    if (codigoAtividade == 1) {
      this.mostrarAlunosPrevencao = true;
      this.mostrarGrupos = false;
      this.mostrarDivTurmas = false;
      this.mostrarDivEquipeEscolar = false;
      this.mostrarDivOutros = false;
    }

    if (codigoAtividade == 2) {
      this.mostrarAlunosPrevencao = false;
      this.mostrarGrupos = true;
    }



  }

  public async OnFileChange(event: any) {
    const maxFileSize = 31 * 1024 * 1024; // 30 MB

    if (event.target.files.length > 0) {
      this.spinnerService.show();
      const formData = new FormData();
      const files = event.target.files;
      for (const file of files) {
        const fileName = file.name.split('.')[0];

        if (fileName.length > 30) {
          const fileInput = document.getElementById('arquivos') as HTMLInputElement;
          if (fileInput) {
            fileInput.value = '';
          }
          this.toastr.warning('O nome do arquivo não pode ter mais de 30 caracteres.');
          this.spinnerService.hide();
          return;
        }

        if (file.size > maxFileSize) {
          this.toastr.warning('O tamanho máximo do arquivo é 30 MB.');
          const fileInput = document.getElementById('arquivos') as HTMLInputElement;
          if (fileInput) {
            fileInput.value = '';
          }
          this.spinnerService.hide();
          return;
        }

        if (file.type == "image/jpg" ||
          file.type == "image/jpeg" ||
          file.type == "image/png" ||
          file.type == "application/pdf" ||
          file.type == "application/ppt" ||
          file.type == "application/pptx" ||
          file.type == "application/potx" ||
          file.type == "application/ppsx" ||
          file.type == "application/odp" ||
          file.type == "audio/mpeg" ||
          file.type == "video/mp4"
        ) {
          formData.append(file.name, file);
        }
        else {
          this.toastr.warning('Só é possivel subir arquivos .jpg, .jpeg , .png, .pdf, .mp3 , .mp4, .ppt, .pptx, .potx e ppsx');
          const fileInput = document.getElementById('arquivos') as HTMLInputElement;
          if (fileInput) {
            fileInput.value = '';
          }
          this.spinnerService.hide();
          return;
        }
      }


      const result = await lastValueFrom(this.arquivoService.setArquivoBase64(formData))
        .catch((err) => {
          return this.errorHandler.handleResultError(err);
        });

      if (!result.isSucess) {
        this.toastr.error(result.message, result.title);
        this.spinnerService.hide();
        return;
      }

      this.files?.push(...result.data);
      event.target.value = '';
      this.spinnerService.hide();
    }
  }

  public removeFile(index: number) {
    this.files.splice(index, 1);
    const fileInput = document.getElementById('arquivos') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }


  public removeUniqueId(fileName: string): string {
    const regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}-/;
    return fileName.replace(regex, '');
  }

  public isImageFile(fileName: string): boolean {
    const lowerName = fileName.toLowerCase();
    return !lowerName.includes('pdf') && !lowerName.includes('mp3') && !lowerName.includes('mp4');
  }

  public AbreModalAluno() {
    this.showModalAluno = true;
    this.formModalAluno = new FormGroup({
      codigoDiretoriaModal: new FormControl(null),
      codigoEscolaModal: new FormControl(null),
      raAlunoModalDrop: new FormControl(null),
      raNomeAluno: new FormControl(null, [Validators.required])
    })
    this.UserBehavior();
  }

  public removeAluno(codigoAluno: number) {
    this.alunosSelecionados = this.alunosSelecionados.filter(x => x.codigoAluno != codigoAluno)
  }

  public FecharModalAluno() {
    this.showModalAluno = false;

    const campos = ['codigoDiretoriaModal', 'codigoEscolaModal', 'raNomeAluno'];
    campos.forEach(campo => {
      const controle = this.formModalAluno.get(campo);
      if (controle) {
        controle.clearValidators();
        controle.updateValueAndValidity();
      }
    });

    this.resetModalEnvolvidos();
  }

  public resetModalEnvolvidos() {
    this.formModalAluno.reset();

  }

  public OnAdicionarEnvolvido() {
    if (this.formModalAluno.invalid) {
      this.toastr.warning("Selecione um aluno para salvar na atividade.");
      return;
    }

    const alunoSelecionado = this.alunos.find(x => x.ra == this.formModalAluno.get('raAlunoModalDrop')?.value)!;

    if (alunoSelecionado == undefined || alunoSelecionado == null) {
      this.toastr.warning("Selecione um aluno para salvar na atividade.");
      return;
    }
    if (this.alunosSelecionados.some(x => x.codigoAluno == alunoSelecionado.codigoAluno)) {
      this.toastr.warning("Aluno já adicionado.");
      return;
    }
    this.alunosSelecionados.push(alunoSelecionado);
    this.showDropAuxiliar = false;
    this.showModalAluno = false;
    this.resetModalEnvolvidos();
  }

  public async getEscolasModalEnvolvidos(equipeEscolar: boolean = false) {
    this.spinnerService.show();
    this.zerarEscolaModal();

    const form = equipeEscolar ? this.formModalEquipeEscolar : this.formModalAluno;

    const codigoDE = form.get('codigoDiretoriaModal')?.value;

    if (codigoDE) {
      const result = await lastValueFrom(this.escolaService.getEscolasPorCodigoDiretoria(codigoDE))
        .catch((err) => {
          return this.errorHandler.handleResultError(err);
        });
      if (!result.isSucess) {
        this.toastr.error(result.message, result.title);
        this.spinnerService.hide();
        return;
      }

      this.escolasModalAlunos = result.data;
      form.get('codigoEscolaModal')?.enable();
      this.spinnerService.hide();
    } else {
      this.escolasModalAlunos = [];
      this.spinnerService.hide();
    }
  }

  zerarEscolaModal() {
    this.escolasModalAlunos = [];
  }


  public BuscarAlunoPorNomeRA() {
    const regexNumeros = /\d$/;
    const regexLetras = /^[a-zA-Z]+$/;
    const regexAmbos = /^[a-zA-Z0-9]+$/;

    this.formModalAluno.get('raAlunoModalDrop')?.patchValue(null);
    this.formModalAluno.get('raAlunoModalDrop')?.removeValidators([Validators.required]);
    this.validaBuscaRA = false;
    const nomeRa = this.formModalAluno.get('raNomeAluno')?.value;



    let buscarPorRa = false;

    if (regexNumeros.test(nomeRa)) {
      this.formModalAluno.get('codigoDiretoriaModal')?.clearAsyncValidators();
      this.formModalAluno.get('codigoEscolaModal')?.clearAsyncValidators();
      buscarPorRa = true;
    }
    else if (regexLetras.test(nomeRa)) {
      this.validaBuscaRA = true;
      this.formModalAluno.get('codigoDiretoriaModal')?.addValidators([Validators.required]);
      this.formModalAluno.get('codigoEscolaModal')?.addValidators([Validators.required]);
    }
    else if (regexAmbos.test(nomeRa)) {
      this.validaBuscaRA = true;
      this.formModalAluno.get('raNomeAluno')?.setValue(nomeRa.replace(/\d/g, ''));
    }
    else {
    }
    this.AtualizarValidacoesAlunos();

    if (!this.formModalAluno.get('raNomeAluno')?.value) {
      this.toastr.warning("Informe o RA ou Nome do Aluno.");
      return;
    }
    if (buscarPorRa) {
      this.getAlunosPorRa();
    } else {
      this.getAlunosPorNome();
    }
    this.formModalAluno.get('raAlunoModalDrop')?.addValidators([Validators.required]);
    this.AtualizarValidacoesAlunos();
  }

  public AtualizarValidacoesAlunos() {
    this.formModalAluno.get('codigoDiretoriaModal')?.updateValueAndValidity();
    this.formModalAluno.get('codigoEscolaModal')?.updateValueAndValidity();
    this.formModalAluno.get('raNomeAluno')?.updateValueAndValidity();
    this.formModalAluno.get('raAlunoModalDrop')?.updateValueAndValidity();
  }

  public async getAlunosPorRa() {
    this.spinnerService.show();
    this.showDropAuxiliar = false;
    const raAluno = this.formModalAluno.get('raNomeAluno');
    const result = await lastValueFrom(this.alunoService.getAlunosPorRa(raAluno?.value))
      .catch((err) => {
        return this.errorHandler.handleResultError(err);
      });
    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      this.spinnerService.hide();
      return;
    }
    this.RetornoBuscaAlunoPorRA(result);
    this.spinnerService.hide();
  }

  private RetornoBuscaAlunoPorRA(response: DefaultResponse) {
    if (response.data != null) {
      this.aluno = response.data;
      this.formModalAluno.get('raAlunoModalDrop')?.patchValue(response.data.ra);
      this.alunos.push(this.aluno);
      this.showDropAuxiliar = true;
      this.toastr.success('Aluno carregado com sucesso.');
      return;
    }
    this.toastr.warning('Nenhum aluno encontrado!');
  }

  public async getAlunosPorNome() {
    const nmAluno = this.formModalAluno.get('raNomeAluno')?.value;
    const codigoDiretoria = this.formModalAluno.get('codigoDiretoriaModal')?.value;
    const codigoEscola = this.formModalAluno.get('codigoEscolaModal')?.value;
    if (codigoDiretoria == null || codigoEscola == null) {
      this.toastr.warning('Para buscar por Nome, informe DE e Escola do aluno.');
      return;
    }
    this.spinnerService.show();
    this.showDropAuxiliar = false;
    const result = await lastValueFrom(this.alunoService.getAlunosPorNome(nmAluno, codigoDiretoria, codigoEscola))
      .catch((err) => {
        return this.errorHandler.handleResultError(err);
      });
    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      this.spinnerService.hide();
      return;
    }
    this.RetornoBuscaAlunos(result);
    this.spinnerService.hide();
  }

  private RetornoBuscaAlunos(response: DefaultResponse) {
    if (response.data != null) {
      this.alunos = response.data;
    }
    if (this.alunos.length == 0) {
      this.toastr.warning('Nenhum aluno encontrado!');
    }
    if (this.alunos.length == 1) {
      this.formModalAluno.get('raAlunoModalDrop')?.patchValue(this.alunos[0].ra);
    }
    if (this.alunos.length > 1) {
      this.toastr.success('Alunos carregados com sucesso. Por favor selecione um.');
    }
    this.showDropAuxiliar = true;
  }


  public async UserBehavior() {


    if (this.userLogado?.flPsicologo) {
      await this.getDiretoriasPerfilPsicologo();
    }
    else {
      if (this.atribuicoesLogin.NumeroComportamento == 1) {
        await this.getDiretoriasAdmin();
      }

      if (this.atribuicoesLogin.NumeroComportamento == 2) {
        await this.getDiretoriasPerfilDiretoria();
      }

      if (this.atribuicoesLogin.NumeroComportamento == 3 ||
        this.atribuicoesLogin.NumeroComportamento == 4) {
        await this.getDiretoriasPerfilEscola();
      }
    }


    // this.disableVoidInputs();
    await this.activeDiretoria();
  }


  private async getDiretoriasPerfilPsicologo() {
    this.spinnerService.show();
    const response = await lastValueFrom(this.psicologoService.getDiretoriaPorPolo(this.userLogado!.codigoPolo));
    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.diretorias = response.data;
    this.spinnerService.hide();


  }

  public async getDiretoriasAdmin() {
    this.spinnerService.show();


    const response = await lastValueFrom(this.escolaService.getDiretoriaPorTipoDiretoria())
      .catch((err) => {
        return this.errorHandler.handleResultError(err);
      });

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.diretorias = response.data;
    this.spinnerService.hide();


  }


  public getDiretoriasPerfilDiretoria() {
    this.diretorias = [];
    this.escolas = [];
    this.spinnerService.show();

    this.userLogado?.DadosUsuario?.map((item: AtribuicaoLoginSed) => {
      const diretoria = new Diretoria();
      diretoria.codigoDiretoria = item.CodigoDiretoria;
      diretoria.nomeDiretoria = item.NomeDiretoria;
      this.diretorias.push(diretoria);

    });

    if (this.diretorias.length === 1) {
      this.formInserir.get('codigoDiretoria')!.disable();
    }

    this.spinnerService.hide();

  }


  public getDiretoriasPerfilEscola() {

    this.diretorias = [];
    this.escolas = [];

    this.spinnerService.show();
    this.userLogado?.DadosUsuario?.map((item: AtribuicaoLoginSed) => {
      const diretoria = new Diretoria();
      diretoria.codigoDiretoria = item.CodigoDiretoria;
      diretoria.nomeDiretoria = item.NomeDiretoria;
      this.diretorias.push(diretoria);

      const escola = new Escola();
      escola.codigoEscola = item.CodigoEscola;
      escola.nomeEscola = item.NomeEscola;
      escola.codigoDiretoria = item.CodigoDiretoria;
      this.escolas.push(escola);
      this.escolasDiretor.push(escola);

    });
    this.spinnerService.hide();



  }

  //   disableVoidInputs() {

  //   // if(this.template == TemplateFiltroPadrao.Polo){
  //   //   this.form.codigoDiretoria.setValue(null);
  //   //   this.form.codigoDiretoria.disable();
  //   // }
  //   this.formInserir.get('codigoDiretoria')!.setValue(null);
  //   this.formInserir.get('codigoDiretoria')!.disable();
  //   this.formInserir.get('codigoEscola')!.setValue(null);
  //   this.formInserir.get('codigoEscola')!.disable();
  // }


  async activeDiretoria() {

    if (this.diretorias != undefined && this.userLogado?.codigoDiretoria != 0) {
      const diretoria = this.diretorias.find(s => s.codigoDiretoria == this.userLogado?.codigoDiretoria)
      if (diretoria) {
        this.formInserir.get('codigoDiretoria')?.setValue(this.userLogado?.codigoDiretoria);
        this.formInserir.get('codigoDiretoria')?.enable();
        await this.getEscolas();
      }
    }
  }


  async activeEscola() {
    if (this.escolas != undefined && this.userLogado?.codigoEscola != 0) {
      const escola = this.escolas.find(s => s.codigoEscola == this.userLogado?.codigoEscola)
      if (escola) {
        this.formInserir.get('codigoEscola')?.setValue(this.userLogado?.codigoEscola);
      }
    }
  }

  public async getEscolas() {
    this.spinnerService.show();

    const codigoDE = this.formInserir.get('codigoDiretoria');
    if (this.userLogado?.DadosUsuario[0]?.NumeroComportamento == 1 ||
      this.userLogado?.DadosUsuario[0]?.NumeroComportamento == 2 ||
      this.userLogado?.DadosUsuario[0].CodigoPerfil == Perfil.Psicólogo) {
      //this.zerarEscola();
      if (codigoDE?.value != null) {
        this.spinnerService.show();
        const response = await lastValueFrom(this.escolaService.getEscolasPorCodigoDiretoria(codigoDE?.value));
        if (!response.isSucess) {
          this.toastr.error(response.message);
        }
        this.escolas = response.data;
        this.formInserir.get('codigoEscola')!.enable();
        this.spinnerService.hide();
      }
    }
    this.spinnerService.hide();
  }


  public async mostrarTipoGrupo() {
    this.userLogado = this.authService.getUser();
    const tipoGrupo = this.formInserir.get('tipoGrupo')?.value;
    this.OnLimparEnvolvidos();

    if (tipoGrupo == 1) {


      //turmas participantes da atividade
      this.mostrarDivEquipeEscolar = false;
      this.mostrarDivOutros = false;
      this.mostrarDivTurmas = true;
      if (this.filtros.codigoEscola) {
        this.carregarTurmas();
      }
      // this.mostrarDivOutros = false;
    } else if (tipoGrupo == 2) {
      // equipe escolar
      this.mostrarDivTurmas = false;
      this.mostrarDivEquipeEscolar = true;
      this.mostrarDivOutros = false;
    } else if (tipoGrupo == 3) {
      // outros
      this.mostrarDivTurmas = false;
      this.mostrarDivEquipeEscolar = false;
      this.mostrarDivOutros = true;
    } else {
      this.mostrarDivTurmas = false;
      this.mostrarDivEquipeEscolar = false;
      this.mostrarDivOutros = false;
    }
  }

  public OnLimparEnvolvidos() {
    this.spinnerService.show();
    this.lstTurmas = [];
    this.lstTurmasAtivas = [];
    // this.lstTurmaAluno = [];
    //this.lstEnvolvidos = [];
    // this.lstTurmasAtivas = [];
    // this.lstFuncionarios = [];
    // this.lstFuncionariosSelecionados = [];
    this.lstEnvolvidosSelecionados = [];
    this.alunosSelecionados = [];
    // this.files = [];
    // this.envolvidos = [];
    // this.showGridTurma = false;
    // this.mostrarDivEquipeEscolar = false;
    this.mostrarDivTurmas = false;
    // this.mostrarDivOutros = false;
    this.spinnerService.hide();
  }


  public async onCheckTurma(codigoTurma: number, descricaoTurma: string) {
    let existeEmLista: boolean = false;
    this.lstTurmasAtivas.forEach(element => {
      if (element == codigoTurma) {
        existeEmLista = true;
      }
    });
    if (existeEmLista) {
      const index = this.lstTurmasAtivas.indexOf(codigoTurma)
      this.lstTurmasAtivas.splice(index, 1);
      this.lstTurmasSelecionadas.splice(index, 1);
      this.lstEnvolvidosSelecionados.splice(index, 1);
    } else {
      this.lstTurmasAtivas.push(codigoTurma);

      const turma = this.lstTurmas.find((fun) => fun.codigoTurma === codigoTurma);
      if (turma != null)
        this.lstTurmasSelecionadas.push(turma);

      const objetoEnvolvido: Envolvido = {
        tipoPessoa: 4,
        tipoEnvolvido: 0,
        nome: descricaoTurma,
        codigoTurma: codigoTurma,
        numeroClasse: turma?.numeroClasse,
        nomeTipoEnsino: turma?.nomeTipoEnsino,
        numeroSerie: turma?.numeroSerie,
        descricaoTurma: turma?.descricaoTurma
      };

      objetoEnvolvido.idTemporario = this.envolvidos.reduce((maxId, envolvido) => Math.max(maxId, envolvido.idTemporario || 0), 0) + 1;
      this.envolvidos.push(objetoEnvolvido);
      this.lstEnvolvidosSelecionados.push(objetoEnvolvido);
    }
  }

  public OnExcluirEquipeEscolar(equipeEscolar: Funcionario) {
    this.lstFuncionariosSelecionados = this.lstFuncionariosSelecionados.filter(
      (envolvido) => envolvido.cpf !== equipeEscolar.cpf
    );
  }

  public AbrirModalEquipeEscolar() {
    this.submittedModal = false;
    this.formModalEquipeEscolar = new FormGroup({
      cpfFuncionario: new FormControl(null, [
        Validators.required,
        this.genericValidate.ValidaCpf,
      ]),
      cpfFuncionarioModalDrop: new FormControl(null, [Validators.required]),
      nomeFuncionario: new FormControl(null, [Validators.required]),
      codigoDiretoriaModal: new FormControl(null, [Validators.required]),
      codigoEscolaModal: new FormControl(null, [Validators.required]),
    });
    this.showModalEquipeEscolar = true;
    this.lstFuncionarios = [];
    this.showBuscarPorNome = false;

    this.UserBehavior();
  }

  public FecharModalEquipeEscolar() {
    this.showModalEquipeEscolar = false;
    this.lstFuncionarios = [];
    this.showBuscarPorNome = false;
  }

  public OnAdicionarEquipeEscolar() {
    this.submittedModal = true;

    // Verificar apenas os campos do modo atual
    if (this.showBuscarPorNome) {
      // Modo NOME: validar campos de nome
      if (this.formModalEquipeEscolar.get('nomeFuncionario')?.invalid ||
          this.formModalEquipeEscolar.get('codigoDiretoriaModal')?.invalid ||
          this.formModalEquipeEscolar.get('codigoEscolaModal')?.invalid ||
          this.formModalEquipeEscolar.get('cpfFuncionarioModalDrop')?.invalid) {
        this.toastr.error("Preencha todos os campos obrigatórios do modo Nome");
        return;
      }
    } else {
      // Modo CPF: validar apenas campos de CPF
      if (this.formModalEquipeEscolar.get('cpfFuncionario')?.invalid ||
          this.formModalEquipeEscolar.get('cpfFuncionarioModalDrop')?.invalid) {
        this.toastr.error("Preencha todos os campos obrigatórios do modo CPF");
        return;
      }
    }

    const funcionario = this.lstFuncionarios.find(x => x.cpf == this.formModalEquipeEscolar.get('cpfFuncionarioModalDrop')?.value);
    if (!funcionario) {
      this.toastr.error("Funcionário não encontrado");
      return;
    }

    this.lstFuncionariosSelecionados.push(funcionario);
    this.toastr.success(`Equipe Escolar inserida com sucesso`);
    this.FecharModalEquipeEscolar();
  }


  OnChangeCountLetters(campo: number) {
    const avalia = this.formInserir.get('acaoRealizada')?.value;
    const impacto = this.formInserir.get('proximosPassos')?.value;
    if (campo == 1)
      this.qtdeCaracteresAcao = avalia ? String(avalia).length : 0;
    if (campo == 2)
      this.qtdeCaracteresPassos = impacto ? String(impacto).length : 0;
  }

  public AbrirModalOutros() {
    this.submittedModal = false;
    this.formModalOutros = new FormGroup({
      dsOutros: new FormControl(null, [Validators.required]),
    });
    this.showModalOutros = true;
  }


  public OnExcluirOutro(outro: string) {
    this.lstOutros = this.lstOutros.filter(x => x !== outro);
  }


  public async GetFuncionariosPorCpf(tela: number) {
    const cpf = tela == 1 ? this.formModalEquipeEscolar.get('cpfFuncionario')?.value : this.formModalEquipeEscolar.get('cpfBusca')?.value;
    if (!this.validarCPF(cpf)) {
      this.toastr.warning('CPF invalido.');
      this.spinnerService.hide();
      return;
    }
    this.showDropAuxiliar = false;
    this.showDropFuncionarios = false;
    this.spinnerService.show();
    let getCPF = undefined;
    if (tela == 1) {
      getCPF = this.formModalEquipeEscolar.get('cpfFuncionario');
    }
    else {
      getCPF = this.formModalEquipeEscolar.get('cpfBusca');
    }
    const result = await lastValueFrom(this.funcionarioService.getFuncionariosPorCpf(getCPF?.value.replace(".", "").replace("-", "")))
      .catch((err) => {
        return this.errorHandler.handleResultError(err);
      });
    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      this.spinnerService.hide();
      return;
    }
    if (result.data != null) {
      this.lstFuncionarios = result.data;
    }
    if (tela == 2) { this.showDropFuncionarios = true; } else { this.showDropAuxiliar = true; }
    if (this.lstFuncionarios.length == 0) {
      this.toastr.warning('Nenhum funcionario encontrado!');
    } else {
      if (this.lstFuncionarios.length == 1) {
        if (tela == 1) {
          this.formModalEquipeEscolar.get('cpfFuncionarioModalDrop')?.patchValue(this.lstFuncionarios[0].cpf);
        } else {
          this.formModalEquipeEscolar.get('cpfProfissionalSelecionado')?.patchValue(this.lstFuncionarios[0].cpf);
        }

      }
    }

    this.spinnerService.hide();
  }

  validarCPF(cpf: string): boolean {
    cpf = cpf.replace(/[^\d]/g, '');
    if (cpf.length !== 11) {
      return false;
    }
    if (/^(\d)\1+$/.test(cpf)) {
      return false;
    }
    let sum = 0;
    let remainder;
    for (let i = 1; i <= 9; i++) {
      sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i);
    }
    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) {
      remainder = 0;
    }
    if (remainder !== parseInt(cpf.substring(9, 10))) {
      return false;
    }
    sum = 0;
    for (let i = 1; i <= 10; i++) {
      sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i);
    }
    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) {
      remainder = 0;
    }
    return remainder === parseInt(cpf.substring(10, 11));
  }

  public async GetFuncionariosPorNome() {
    const nomeFuncionario = this.formModalEquipeEscolar.get('nomeFuncionario')?.value;
    const codigoEscola = this.formModalEquipeEscolar.get('codigoEscolaModal')?.value;

    // Validação do nome do funcionário
    if (!nomeFuncionario || nomeFuncionario.trim() === '') {
      this.toastr.warning('Nome do funcionário é obrigatório.');
      this.spinnerService.hide();
      return;
    }

    // Validação do código da escola
    if (!codigoEscola || codigoEscola === 0) {
      this.toastr.warning('Selecione uma escola válida.');
      this.spinnerService.hide();
      return;
    }

    this.showDropAuxiliar = false;
    this.showDropFuncionarios = false;
    this.spinnerService.show();

    const result = await lastValueFrom(this.funcionarioService.getFuncionariosPorNome(nomeFuncionario.trim(), codigoEscola))
      .catch((err) => {
        return this.errorHandler.handleResultError(err);
      });
    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      this.spinnerService.hide();
      return;
    }
    if (result.data != null) {
      this.lstFuncionarios = result.data;
    }

    if (this.lstFuncionarios.length == 0) {
      this.toastr.warning('Nenhum funcionario encontrado!');
    } else {
      if (this.lstFuncionarios.length == 1) {
          this.formModalEquipeEscolar.get('cpfFuncionarioModalDrop')?.patchValue(this.lstFuncionarios[0].cpf);
      }
    }

    this.spinnerService.hide();
  }

  public OnAdicionarOutros(): void {
    this.submittedModal = true;

    if (this.formModalOutros.invalid) {
      this.toastr.error("Campo de descrição obrigatório");
      return;
    }
    const descricao = this.formModalOutros.get('dsOutros')!.value as string;


    this.lstOutros.push(descricao);


    this.toastr.success("Descrição adicionada com sucesso!");
    this.formModalOutros.reset();
    this.submittedModal = false;
    this.FecharModalOutros();
  }

  public FecharModalOutros() {
    this.showModalOutros = false;
  }
  public onVoltar() {
    setTimeout(() => {
      this.location.back();
    }, 5000);

  }

  poloHandler(codigoPolo: number) {
    // Troca de Polo limpa URE/Escola no filtro interno; alinhar `this.filtros` para não manter URE antiga na validação.
    this.filtros = {
      ...this.filtros,
      codigoPolo: codigoPolo ?? 0,
      codigoDiretoria: 0,
      codigoEscola: 0,
    };
    this.filtroService.atualizaFiltro(this.filtros);
  }

  async diretoriaHandler(codigoDiretoria: number) {

    this.spinnerService.show();

    const response = await lastValueFrom(this.escolaService.getEscolasPorCodigoDiretoria(codigoDiretoria!));

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.escolas = response.data;
    this.spinnerService.hide();

    // O filtro do cabeçalho mantém Polo/URE/Escola no FormGroup interno do `app-filtro-padrao`;
    // `this.filtros` só era preenchido no clique em Pesquisar. Sem isso, validações como
    // `onTipoAtividadeChange` liam `codigoDiretoria` vazio mesmo com URE visível na UI.
    this.filtros = {
      ...this.filtros,
      codigoDiretoria: codigoDiretoria ?? 0,
    };
    this.filtroService.atualizaFiltro(this.filtros);

    this.syncPainelTipoAtividadeSeFiltroPronto();

  }

  // private formatElapsed(): string {
  //   const diffSec = Math.floor((performance.now() - this.inicioRegistro) / 1_000);
  //   const mm = String(Math.floor(diffSec / 60)).padStart(2, '0');
  //   const ss = String(diffSec % 60).padStart(2, '0');
  //   return `${mm}:${ss}`;
  // }

  public OnChangeBuscarPorNome() {
    this.showBuscarPorNome = !this.showBuscarPorNome;

    // Resetar valores e limpar erros de TODOS os campos
    const camposParaResetar = [
      'cpfFuncionario',
      'nomeFuncionario',
      'codigoDiretoriaModal',
      'codigoEscolaModal',
      'cpfFuncionarioModalDrop'
    ];

    camposParaResetar.forEach(campo => {
      this.formModalEquipeEscolar.get(campo)?.setValue(null);
      this.formModalEquipeEscolar.get(campo)?.setErrors(null);
    });

    // REMOVER TODOS os validadores primeiro
    camposParaResetar.forEach(campo => {
      this.formModalEquipeEscolar.get(campo)?.clearValidators();
    });

    // ADICIONAR validadores APENAS para os campos relevantes do modo atual
    if (this.showBuscarPorNome) {
      // MODO NOME: nome, diretoria, escola e dropdown são obrigatórios
      this.formModalEquipeEscolar.get('nomeFuncionario')?.setValidators([Validators.required]);
      this.formModalEquipeEscolar.get('codigoDiretoriaModal')?.setValidators([Validators.required]);
      this.formModalEquipeEscolar.get('codigoEscolaModal')?.setValidators([Validators.required]);
      this.formModalEquipeEscolar.get('cpfFuncionarioModalDrop')?.setValidators([Validators.required]);
    } else {
      // MODO CPF: APENAS cpfFuncionario e dropdown são obrigatórios
      this.formModalEquipeEscolar.get('cpfFuncionario')?.setValidators([
        Validators.required,
        this.genericValidate.ValidaCpf
      ]);
      this.formModalEquipeEscolar.get('cpfFuncionarioModalDrop')?.setValidators([Validators.required]);
    }

    // ATUALIZAR validações de TODOS os campos
    camposParaResetar.forEach(campo => {
      this.formModalEquipeEscolar.get(campo)?.updateValueAndValidity();
    });

    this.lstFuncionarios = [];
    this.showDropAuxiliar = false;
    this.submittedModal = false;
  }

  removerPorCodigoEnvolvido(codigoEnvolvido: number): void {
    const indice = this.lstEnvolvidosSelecionados.findIndex(env => env.codigoEnvolvido === codigoEnvolvido);
    if (indice !== -1) {
      this.lstEnvolvidosSelecionados.splice(indice, 1);
    }
  }

  removerJsonPorCodigoEnvolvido(codigoEnvolvido: number): void {
    const indice = this.jsonEnvolvidoAgendamento.findIndex(env => env.codigoEnvolvido === codigoEnvolvido);
    if (indice !== -1) {
      this.jsonEnvolvidoAgendamento.splice(indice, 1);
    }
  }

  addJsonPorCodigoEnvolvido(codigoEnvolvido: number, codigoAgendamento: number): void {
    this.jsonEnvolvidoAgendamento.push({"codigoEnvolvido": codigoEnvolvido, "codigoAgendamento": codigoAgendamento });
  }


}


